import React from "react";

/*
 * Apresenta um texto com a marcação simples usada nas notificações:
 * o trecho entre ** aparece em negrito. A quebra de linha é respeitada pelo CSS de quem usa (white-space: pre-wrap).
 * OBS: Monta os elementos do React e não interpreta HTML (o texto pode ter conteúdo digitado pelo usuário)
 */
export default function TextoFormatado({ texto }) {
  const partes = String(texto ?? "").split("**");

  return (
    <>
      {partes.map((parte, index) => {
        const isNegrito = index % 2 == 1;

        //Marcação sem o fechamento: apresenta o texto como foi escrito
        if (isNegrito && index == partes.length - 1) {
          return <React.Fragment key={index}>{`**${parte}`}</React.Fragment>;
        }

        return isNegrito ? (
          <strong key={index}>{parte}</strong>
        ) : (
          <React.Fragment key={index}>{parte}</React.Fragment>
        );
      })}
    </>
  );
}
